// Generated by CoffeeScript 1.10.0

/*
 https://gist.github.com/OzzyCzech/9894158
 */
var slice = [].slice;

(function ($, window) {
	var Toggler;
	Toggler = (function () {
		Toggler.prototype["default"] = {
			"class": 'hidden'
		};

		function Toggler(el1, options) {
			this.el = el1;
			this.$el = $(el);
			this.options = $.extend({}, this["default"], options, this.$el.data());
			this.$el.on({
				"click.toggler": $.proxy(this.click, this)
			});
			return this;
		}

		Toggler.prototype.click = function (e) {
			this.hide();
			this.show();
			this.toggle();
			return e.preventDefault();
		};

		Toggler.prototype.hide = function () {
			console.log(this.options.hide);
			if (this.options.hide) {
				return $(this.options.hide).addClass(this.options["class"]);
			}
		};

		Toggler.prototype.show = function () {
			if (this.options.show) {
				return $(this.options.show).removeClass(this.options["class"]);
			}
		};

		Toggler.prototype.toggle = function () {
			if (this.options.toggle) {
				return $(this.options.toggle).toggleClass(this.options["class"]);
			}
		};

		return Toggler;

	})();

	/*
	 jQuery plugin
	 */
	$.fn.extend({
		toggler: function () {
			var args, option;
			option = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
			this.each(function () {
				var $this, data, options;
				$this = $(this);
				data = $this.data('om.toggler');
				options = typeof option === 'object' && option;
				if (!data) {
					$this.data('om.toggler', (data = new Toggler(this, options)));
				}
				if (typeof option === 'string') {
					return data[option].apply(data, args);
				}
			});
			return this;
		}
	});
	return $('.toggler').toggler();
})(jQuery, window);
